/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const plans = (state = defaultState.plans, action) => {
    let nextState = Utilities.deepClone(state);

    if (action.type === constants.SUB_RESET_COUPON) {
        nextState.validatedCoupon = {};
    }

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.SUB_FETCH:
                nextState.current = action.payload;
                break;

            case constants.SUB_FETCH_DETAIL:
                for (let key in nextState.details) {
                    if (nextState.details[key].label === action.payload.label) {
                        nextState.details[key] = action.payload;
                        break;
                    }
                }
                break;

            case constants.SUB_CREATE:
            case constants.SUB_ADDON_UPDATE:
            case constants.SUB_UPDATE:
            case constants.SUB_APPLY_COUPON:
                nextState.current = action.payload;
                // reset the coupon data after a successful sub creation
                nextState.validatedCoupon = {};
                break;

            case constants.SUB_LIMIT_CHECK:
                nextState.limitCheck = action.payload;
                break;

            case constants.SUB_FETCH_PLANS:
                nextState.details = action.payload;
                break;

            case constants.SUB_FETCH_INVOICES:
                nextState.invoices = action.payload;
                break;

            case constants.SUB_FETCH_INVOICE:
                nextState.invoice = action.payload;
                break;

            case constants.SUB_FETCH_BILLING:
                nextState.billingInfo = action.payload;
                break;

            case constants.SUB_UPDATE_BILLING:
                nextState.billingInfo = action.payload;
                break;

            case constants.SUB_UPDATE_PULL_FREQ:
                nextState.updatedPullFreq++;
                break;

            case constants.SUB_VALIDATE_COUPON:
                nextState.validatedCoupon = action.payload;
                break;

            case constants.SUB_VALIDATE_PROMO:
                nextState.promoRedeemed = action.payload.promoRedeemed;
                break;

            default:
                break;

        }
    } else if (action.status === constants.STATE_TXRX) {
        switch (action.type) {
            case constants.SUB_VALIDATE_COUPON:
                nextState.validatedCoupon = {};
                break;

            default:
                break;
        }
    }

    return nextState;
};
